import React, { useContext, useEffect, useState } from "react";
import CallIcon from "@mui/icons-material/Call";
import CryptoJS from "crypto-js";
import SearchIcon from "@mui/icons-material/Search";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";

import { ContextSession } from "../../services/ContextSession";
import { cache } from "react";

const SECRET_KEY =
  "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";
// const REVALORIZACION_API_URL =
// "http://127.0.0.1:8000/api/Revalorizacion/Consultar/";
const REVALORIZACION_API_URL =
  "https://be.injupemp.gob.hn:8443/api/Revalorizacion/Consultar/";
const CALL_CENTER_PHONE = "+504 2290-1900";
const CALL_CENTER_PHONE_HREF = "tel:+50422901900";
const WHATSAPP_SUPPORT_LABEL = "+504 8984-7191";
const WHATSAPP_SUPPORT_URL = "https://wa.link/kbcxjr";
const initialRevalorizacionRequests = new Map();

const formatCurrency = (value) => {
  if (value === null || value === undefined || value === "") {
    return "-";
  }

  const numericValue = Number(value);
  if (Number.isNaN(numericValue)) {
    return value;
  }

  return `L. ${numericValue.toLocaleString("es-HN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

const getStoredAuthData = () => {
  try {
    return JSON.parse(localStorage.getItem("authData") || "{}");
  } catch (error) {
    return {};
  }
};

const getYearFromFecha = (fecha) => {
  const match = String(fecha || "").match(/(19|20)\d{2}/);
  return match ? Number(match[0]) : null;
};

const fetchInitialRevalorizacion = async ({ identidad, usuarioId, token }) => {
  const cacheKey = `${usuarioId || "0"}-${identidad}`;

  if (initialRevalorizacionRequests.has(cacheKey)) {
    return initialRevalorizacionRequests.get(cacheKey);
  }

  const payload = {
    IDENTIDAD: identidad,
    ...(usuarioId ? { UsuarioID: usuarioId } : {}),
  };
  const rawData = `IDENTIDAD=${identidad}`;
  const signature = CryptoJS.HmacSHA256(rawData, SECRET_KEY).toString(
    CryptoJS.enc.Hex,
  );



  /*  const requestPromise = fetch(REVALORIZACION_API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "X-Signature": signature,
    },
    body: JSON.stringify(payload),
  })
    .then(async (response) => ({
      ok: response.ok,
      status: response.status,
      data: await response.json(),
    }))
    .finally(() => {
      initialRevalorizacionRequests.delete(cacheKey);
    });

  initialRevalorizacionRequests.set(cacheKey, requestPromise);
  return requestPromise;
}; */
  const data = [];
  console.log("Identidad===>",identidad);
  if (identidad === '0801193200001' ) {
    data.push(
    {
        "IDENTIDAD": "0801193200001",
        "NOMBRE": "Juan Gabriel Lopez Ruiz",
        "FECHA": "2026-05-25",
        "MONTO_ANTERIOR": 5000.0,
        "REVALORIZACION": 300.0,
        "NUEVO_MONTO": 5300.0
    },
    {
        "IDENTIDAD": "0801193200001",
        "NOMBRE": "Juan Gabriel Lopez Ruiz",
        "FECHA": "2025-06-11",
        "MONTO_ANTERIOR": 4354.6,
        "REVALORIZACION": 645.4,
        "NUEVO_MONTO": 5000.0
    },
    {
        "IDENTIDAD": "0801193200001",
        "NOMBRE": "Juan Gabriel Lopez Ruiz",
        "FECHA": "2024-06-18",
        "MONTO_ANTERIOR": 3924.29,
        "REVALORIZACION": 430.31,
        "NUEVO_MONTO": 4354.6
    },
    {
        "IDENTIDAD": "0801193200001",
        "NOMBRE": "Juan Gabriel Lopez Ruiz",
        "FECHA": "2023-05-18",
        "MONTO_ANTERIOR": 3591.14,
        "REVALORIZACION": 333.15,
        "NUEVO_MONTO": 3924.29
    },
    {
        "IDENTIDAD": "0801193200001",
        "NOMBRE": "Juan Gabriel Lopez Ruiz",
        "FECHA": "2022-05-13",
        "MONTO_ANTERIOR": 3439.14,
        "REVALORIZACION": 152.0,
        "NUEVO_MONTO": 3591.14
    },
    {
        "IDENTIDAD": "0801193200001",
        "NOMBRE": "Juan Gabriel Lopez Ruiz",
        "FECHA": "2021-05-20",
        "MONTO_ANTERIOR": 3315.31,
        "REVALORIZACION": 123.83,
        "NUEVO_MONTO": 3439.14
    }

    );
    return  {
          ok: true,
          status: true,
          data: data,
        };
  } else {
    const requestPromise = fetch(REVALORIZACION_API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "X-Signature": signature,
      },
      body: JSON.stringify(payload),
    })
      .then(async (response) => {
        let data = await response.json();
        console.log(data);
        if (data[0].IDENTIDAD === '0801193200001' && data[0]) {
          data = [
            {
              "IDENTIDAD": "0801193200001",
              "NOMBRE": "Juan Gabriel Lopez Ruiz",
              "FECHA": "2026-05-22",
              "MONTO_ANTERIOR": 34332.56,
              "REVALORIZACION": 500.00,
              "NUEVO_MONTO": 34832.56
            },
            {
              "IDENTIDAD": "0801193200001",
              "NOMBRE": "Juan Gabriel Lopez Ruiz",
              "FECHA": "2025-12-23",
              "MONTO_ANTERIOR": 34030.23,
              "REVALORIZACION": 302.33,
              "NUEVO_MONTO": 34332.56
            },
            {
              "IDENTIDAD": "0801193200001",
              "NOMBRE": "Juan Gabriel Lopez Ruiz",
              "FECHA": "2025-06-11",
              "MONTO_ANTERIOR": 33222.91,
              "REVALORIZACION": 807.32,
              "NUEVO_MONTO": 34030.23
            },
            {
              "IDENTIDAD": "0801193200001",
              "NOMBRE": "Juan Gabriel Lopez Ruiz",
              "FECHA": "2024-06-18",
              "MONTO_ANTERIOR": 32040.61,
              "REVALORIZACION": 1182.3,
              "NUEVO_MONTO": 33222.91
            },
            {
              "IDENTIDAD": "0801193200001",
              "NOMBRE": "Juan Gabriel Lopez Ruiz",
              "FECHA": "2023-05-18",
              "MONTO_ANTERIOR": 31567.1,
              "REVALORIZACION": 473.51,
              "NUEVO_MONTO": 32040.61
            },
            {
              "IDENTIDAD": "0801193200001",
              "NOMBRE": "Juan Gabriel Lopez Ruiz",
              "FECHA": "2022-05-13",
              "MONTO_ANTERIOR": 30355.9,
              "REVALORIZACION": 1211.2,
              "NUEVO_MONTO": 31567.1
            },
            {
              "IDENTIDAD": "0801193200001",
              "NOMBRE": "Juan Gabriel Lopez Ruiz",
              "FECHA": "2021-05-20",
              "MONTO_ANTERIOR": 29355.32,
              "REVALORIZACION": 1000.58,
              "NUEVO_MONTO": 30355.9
            }
          ];
        }
        return {
          ok: response.ok,
          status: response.status,
          data: data,
        }
      })
      .finally(() => {
        initialRevalorizacionRequests.delete(cacheKey);
      });

    initialRevalorizacionRequests.set(cacheKey, requestPromise);
    console.log("promesa de request enviada==>",requestPromise, cacheKey);
    return requestPromise;
  }
};

function RevalorizacionScreen() {
  const isMobile = useMediaQuery("(max-width:820px)");
  const sessi = useContext(ContextSession);
  const storedAuthData = getStoredAuthData();
  const usuarioId = sessi.sessionData.id || storedAuthData.id || "";
  const identidad =
    sessi.sessionData.identidad || storedAuthData.identidad || "";

  const [availableYears, setAvailableYears] = useState([]);
  const [allResultados, setAllResultados] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [loadingInitialData, setLoadingInitialData] = useState(true);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [resultados, setResultados] = useState([]);

  useEffect(() => {
    const fetchAvailableYears = async () => {
      if (!identidad) {
        setErrorMessage(
          "No se encontró el número de identidad del participante en la sesión.",
        );
        setLoadingInitialData(false);
        return;
      }

      setLoadingInitialData(true);
      setErrorMessage("");

       
      try {
        const { ok, status, data } = await fetchInitialRevalorizacion({
          identidad,
          usuarioId,
          token: sessi.sessionData.token,
        });

        if (!ok) {
          if (status === 404) {
            setAllResultados([]);
            setAvailableYears([]);
            setSelectedYear("");
            setResultados([]);
            return;
          }

          throw new Error(
            data?.error || "No se pudo obtener la revalorización disponible.",
          );
        }
        
        const registros = Array.isArray(data) ? data : [];
        const years = [
          ...new Set(
            registros
              .map((item) => getYearFromFecha(item.FECHA))
              .filter((item) => item !== null),
          ),
        ].sort((a, b) => b - a);

        if (years.length === 0) {
          setAllResultados([]);
          setAvailableYears([]);
          setSelectedYear("");
          setResultados([]);
          return;
        }

        const initialYear = years[0];

        setAllResultados(registros);
        setAvailableYears(years);
        setSelectedYear(initialYear);
        setResultados(
          registros.filter(
            (item) => getYearFromFecha(item.FECHA) === initialYear,
          ),
        );
      } catch (error) {
        setAllResultados([]);
        setAvailableYears([]);
        setSelectedYear("");
        setResultados([]);
        setErrorMessage(
          error.message || "Ocurrió un error al consultar la revalorización.",
        );
      } finally {
        setLoadingInitialData(false);
      }
    };

    fetchAvailableYears();
  }, [identidad, usuarioId, sessi.sessionData.token]);

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
    setErrorMessage("");
  };

  const handleConsultar = async () => {
    if (!selectedYear) {
      setResultados([]);
      setErrorMessage("No hay años disponibles para consultar.");
      return;
    }

    setLoading(true);
    setErrorMessage("");

    const payload = {
      IDENTIDAD: identidad,
      ANIO: Number(selectedYear),
      ...(usuarioId ? { UsuarioID: usuarioId } : {}),
    };
    const rawData = `IDENTIDAD=${identidad}`;
    const signature = CryptoJS.HmacSHA256(rawData, SECRET_KEY).toString(
      CryptoJS.enc.Hex,
    );


    if (Number(selectedYear) == 2026 && identidad === "0801193200001") {


      const data = [    {
        "IDENTIDAD": "0801193200001",
        "NOMBRE": "Juan Gabriel Lopez Ruiz",
        "FECHA": "2026-05-25",
        "MONTO_ANTERIOR": 5000.0,
        "REVALORIZACION": 300.0,
        "NUEVO_MONTO": 5300.0
    }];
      const registros = Array.isArray(data) ? data : [];
      setLoading(false);
      setResultados(registros);
      return [...registros];
    }
    try {
      const response = await fetch(REVALORIZACION_API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessi.sessionData.token}`,
          "X-Signature": signature,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (!response.ok) {
        if (response.status === 404) {
          setResultados([]);
          setErrorMessage(
            "No se encontró información para el año seleccionado.",
          );
          return;
        }

        throw new Error(
          data?.error || "No se pudo consultar la revalorización.",
        );
      }

      const registros = Array.isArray(data) ? data : [];
      setResultados(registros);
      setAllResultados((prevResultados) => {
        const otrosAnios = prevResultados.filter(
          (item) => getYearFromFecha(item.FECHA) !== Number(selectedYear),
        );
        return [...otrosAnios, ...registros];
      });
    } catch (error) {
      setResultados([]);
      setErrorMessage(
        error.message || "Ocurrió un error al consultar la revalorización.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container
      maxWidth="lg"
      sx={{ mt: { xs: 1.5, md: 4 }, px: { xs: 1.5, sm: 3 } }}
    >
      <Grid container spacing={{ xs: 2, md: 3 }}>
        <Grid item xs={12}>
          <Typography
            variant={isMobile ? "h5" : "h4"}
            textAlign="center"
            fontWeight="bold"
            sx={{ lineHeight: 1.2 }}
          >
            Consulta de Revalorización
          </Typography>
          <Typography
            variant={isMobile ? "body2" : "body1"}
            textAlign="center"
            color="text.secondary"
            sx={{ mt: 1, mx: "auto", maxWidth: 720 }}
          >
            Seleccione el año para consultar la pensión revalorizada del
            participante autenticado.
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Paper elevation={3} sx={{ p: { xs: 2, md: 3 }, borderRadius: 2 }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  fullWidth
                  label="Número de Identidad"
                  value={identidad}
                  variant="filled"
                  InputProps={{ readOnly: true }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth variant="filled">
                  <InputLabel id="revalorizacion-anio-label">Año</InputLabel>
                  <Select
                    labelId="revalorizacion-anio-label"
                    value={selectedYear}
                    onChange={handleYearChange}
                    label="Año"
                    disabled={loadingInitialData || availableYears.length === 0}
                  >
                    {availableYears.map((year) => (
                      <MenuItem key={year} value={year}>
                        {year}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={4}>
                <Button
                  fullWidth
                  variant="contained"
                  size="large"
                  startIcon={<SearchIcon />}
                  onClick={handleConsultar}
                  disabled={
                    loading || loadingInitialData || availableYears.length === 0
                  }
                  sx={{
                    height: isMobile ? "48px" : "56px",
                    color: "var(--color-white) !important",
                    backgroundColor: "var(--color-brand-primary)",
                    "&:hover": {
                      color: "var(--color-white) !important",
                      backgroundColor: "var(--color-brand-secondary)",
                    },
                    "&:focus, &:active": {
                      color: "var(--color-white) !important",
                    },
                  }}
                >
                  Consultar
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        {errorMessage && (
          <Grid item xs={12}>
            <Alert severity="warning">{errorMessage}</Alert>
          </Grid>
        )}

        {(loadingInitialData || loading) && (
          <Grid item xs={12}>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              py={4}
            >
              <CircularProgress />
              <Typography sx={{ mt: 2 }}>
                Consultando revalorización...
              </Typography>
            </Box>
          </Grid>
        )}

        {!loadingInitialData &&
          !loading &&
          !errorMessage &&
          availableYears.length === 0 && (
            <Grid item xs={12}>
              <Alert severity="info">
                No se encontraron años disponibles de revalorización.
              </Alert>
            </Grid>
          )}

        {!loadingInitialData && !loading && resultados.length > 0 && (
          <Grid item xs={12}>
            <Paper elevation={3} sx={{ p: { xs: 2, md: 2.5 }, borderRadius: 2 }}>
              <Typography
                variant={isMobile ? "subtitle1" : "h6"}
                fontWeight="bold"
                sx={{ mb: 2 }}
              >
                Resultados del año {selectedYear}
              </Typography>

              {isMobile ? (
                <Stack spacing={1.5}>
                  {resultados.map((resultado, index) => (
                    <Paper
                      key={`${resultado.IDENTIDAD}-${resultado.FECHA}-${index}`}
                      variant="outlined"
                      sx={{
                        p: 2,
                        borderRadius: 2,
                        borderColor: "rgba(25, 67, 140, 0.18)",
                        backgroundColor: "rgba(25, 67, 140, 0.03)",
                      }}
                    >
                      <Grid container spacing={1.5}>
                        <Grid item xs={12}>
                          <Typography variant="caption" color="text.secondary">
                            {"Pensi\u00F3n del a\u00F1o anterior"}
                          </Typography>
                          <Typography fontWeight={700}>
                            {formatCurrency(resultado.MONTO_ANTERIOR)}
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography variant="caption" color="text.secondary">
                            {"Revalorizaci\u00F3n"}
                          </Typography>
                          <Typography fontWeight={700}>
                            {formatCurrency(resultado.REVALORIZACION)}
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography variant="caption" color="text.secondary">
                            {"Pensi\u00F3n revalorizada"}
                          </Typography>
                          <Typography fontWeight={700}>
                            {formatCurrency(resultado.NUEVO_MONTO)}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Paper>
                  ))}
                </Stack>
              ) : (
                <TableContainer sx={{ maxWidth: "100%", overflowX: "auto" }}>
                  <Table size="medium" sx={{ minWidth: 680 }}>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          align="center"
                          sx={{
                            backgroundColor: "var(--color-brand-primary)",
                            color: "var(--color-white)",
                            fontWeight: "bold",
                          }}
                        >
                          Pensión del año anterior
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            backgroundColor: "var(--color-brand-primary)",
                            color: "var(--color-white)",
                            fontWeight: "bold",
                          }}
                        >
                          Revalorización
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            backgroundColor: "var(--color-brand-primary)",
                            color: "var(--color-white)",
                            fontWeight: "bold",
                          }}
                        >
                          Pensión revalorizada
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {resultados.map((resultado, index) => (
                        <TableRow
                          key={`${resultado.IDENTIDAD}-${resultado.FECHA}-${index}`}
                        >
                          <TableCell align="center">
                            {formatCurrency(resultado.MONTO_ANTERIOR)}
                          </TableCell>
                          <TableCell align="center">
                            {formatCurrency(resultado.REVALORIZACION)}
                          </TableCell>
                          <TableCell align="center">
                            {formatCurrency(resultado.NUEVO_MONTO)}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </Paper>
          </Grid>
        )}

        {/*  < Grid item xs={12}>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 2, sm: 2.25, md: 2.5 },
              border: "1px solid rgba(25, 67, 140, 0.16)",
              borderRadius: { xs: 1.5, md: 2 },
              background:
                "linear-gradient(135deg, rgba(25, 67, 140, 0.06), rgba(37, 211, 102, 0.08))",
            }}
          >
            <Grid container spacing={{ xs: 1.5, md: 2 }} alignItems="center">
              <Grid item xs={12} md={6}>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  textAlign={{ xs: "center", md: "left" }}
                >
                  {
                    "Para cualquier consulta sobre su revalorizaci\u00F3n, puede comunicarse con nuestro Call Center o escribirnos por WhatsApp."
                  }
                </Typography>
              </Grid>

              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    gap: 1.5,
                    justifyContent: { xs: "center", md: "flex-end" },
                    alignItems: { xs: "stretch", sm: "center" },
                    flexWrap: "wrap",
                  }}
                >
                  <Button
                    component="a"
                    href={CALL_CENTER_PHONE_HREF}
                    variant="contained"
                    startIcon={<CallIcon />}
                    sx={{
                      width: { xs: "100%", sm: "auto" },
                      minHeight: 46,
                      px: 2.5,
                      borderRadius: 999,
                      justifyContent: "center",
                      textTransform: "none",
                      whiteSpace: "nowrap",
                      fontSize: { xs: "0.85rem", sm: "0.875rem" },
                      fontWeight: 700,
                      color: "#fff !important",
                      backgroundColor: "var(--color-brand-primary)",
                      boxShadow: "0 10px 22px rgba(25, 67, 140, 0.22)",
                      "& .MuiButton-startIcon, & .MuiSvgIcon-root": {
                        color: "#fff",
                      },
                      "&:hover": {
                        color: "#fff !important",
                        backgroundColor: "var(--color-brand-secondary)",
                        boxShadow: "0 12px 26px rgba(25, 67, 140, 0.3)",
                      },
                      "&:focus, &:active, &:visited": {
                        color: "#fff !important",
                      },
                    }}
                  >
                    Call Center {CALL_CENTER_PHONE}
                  </Button>
                  <Button
                    component="a"
                    href={WHATSAPP_SUPPORT_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="contained"
                    startIcon={<WhatsAppIcon />}
                    sx={{
                      width: { xs: "100%", sm: "auto" },
                      minHeight: 46,
                      px: 2.5,
                      borderRadius: 999,
                      justifyContent: "center",
                      textTransform: "none",
                      whiteSpace: "nowrap",
                      fontSize: { xs: "0.85rem", sm: "0.875rem" },
                      fontWeight: 700,
                      backgroundColor: "#25D366",
                      color: "#fff !important",
                      boxShadow: "0 10px 22px rgba(37, 211, 102, 0.24)",
                      "& .MuiButton-startIcon, & .MuiSvgIcon-root": {
                        color: "#fff",
                      },
                      "&:hover": {
                        color: "#fff !important",
                        backgroundColor: "#1da851",
                        boxShadow: "0 12px 26px rgba(37, 211, 102, 0.3)",
                      },
                      "&:focus, &:active, &:visited": {
                        color: "#fff !important",
                      },
                    }}
                  >
                    WhatsApp {WHATSAPP_SUPPORT_LABEL}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Paper>
        </Grid> */}
      </Grid>
    </Container>
  );
}

export default RevalorizacionScreen;
